<template>
    <mini-table :entity-name="entityName"
                :custom-vuex-name="customVuexName"
                :items="rows"
                need-model-fields
                read-only
                with-custom-actions-head-of-row
                custom-head-of-row-label="状态">
        <template #headOfRow="{row}">
            <template v-if="runningStatusMap[row.id]">
                <b-spinner small v-if="runningStatusMap[row.id].loading" type="border"></b-spinner>
                <i v-else :class="runningStatusMap[row.id].class"></i>
                <div v-if="runningStatusMap[row.id].isFailed" class="error-msg">
                    {{ errorMsg[row.id] }}
                </div>
            </template>
        </template>
    </mini-table>
</template>

<script>
export const RUN = {
    START: {loading: true},
    DONE: {class: 'fa-solid fa-check text-success', isSucceeded: true},
    FAILED: {class: 'fa-solid fa-xmark text-danger', isFailed: true},
    SKIP: {class: 'fa-solid fa-arrow-right text-secondary'}
}

import MiniTable from "@/components/common/mini-table/MiniTable.vue";

export default {
    name: "ExecuteViewTable",
    components: {MiniTable},
    props: {
        rows: {
            type: Array
        },
        entityName: String,
        customVuexName: String,
    },
    data() {
        return {
            runningStatusMap: {},
            errorMsg: {},
        }
    },
    methods: {
        setStatus(id, tag, msg) {
            this.$set(this.runningStatusMap, id, tag)
            if (msg) {
                this.$set(this.errorMsg, id, msg);
            }
        },
        checkSuccess(id) {
            let runStatus = this.runningStatusMap[id];
            return runStatus && runStatus.isSucceeded;
        },
        checkAllSuccess() {
            for (let row of this.rows) {
                let runStatus = this.runningStatusMap[row.id];
                if (!runStatus || !runStatus.isSucceeded) {
                    return false;
                }
            }
            return true;
        },
        clearRunningStatus() {
            this.runningStatusMap = {};
            this.errorMsg = {};
        },
    }
}
</script>

<style scoped>
.error-msg {
    max-width: 230px;
    word-break: break-word;
}
</style>
